import React from 'react';

const MmcButton = ({
    children,
    variant = 'secondary',
    size = 'md',
    icon: Icon = null,
    className = '',
    ...props
}) => {
    const variantClass = variant === 'primary' ? 'mmc-btn--primary' : (variant === 'ghost' ? 'mmc-btn--ghost' : '');

    return (
        <button
            className={`mmc-btn ${variantClass} ${className}`}
            {...props}
        >
            {Icon && <Icon size={size === 'sm' ? 14 : 18} weight="bold" />}
            {children}
        </button>
    );
};

export default MmcButton;
